module.exports = __webpack_public_path__ + "static/img/row10.6f5e203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row10.png
// module id = N4e4
// module chunks = 12